import { render } from "./FormWindow.vue?vue&type=template&id=e63dd57a&scoped=true"
import script from "./FormWindow.vue?vue&type=script&lang=js"
export * from "./FormWindow.vue?vue&type=script&lang=js"

import "./FormWindow.vue?vue&type=style&index=0&id=e63dd57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63dd57a"]])

export default __exports__